import './switch.scss';
import './switch.dark-mode.scss'
import React from 'react';
import PropTypes from 'prop-types';

const FormSwitch = ({ children, size, id, name, disabled, checked, onChange }) => (
  <div className={`checkbox__switch ${size && size === 'small' ? 'checkbox__switch-small' : ''}`}>
    <label className="checkbox__switch-form">
      <input
        name={name}
        type="checkbox"
        id={id}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
      />
      <span className="slider-form round" />
    </label>
    <label
      htmlFor={name}
      className={`checkbox__switch-label checkbox__switch-label-${name}`}
    >
      {children}
    </label>
  </div>
)

FormSwitch.propTypes = {
  children: PropTypes.any,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FormSwitch;
